import { ValidatorFunction } from "src/app/models/validator";
import { PhoneNumberService } from "src/app/services/phone-number.service";

export function phoneValidator(phoneNumberService: PhoneNumberService): ValidatorFunction {
  return function (control) {
    const value = String(control.value);
    if (!value.startsWith('+')) {
      return { error: "Invalid country code" };
    }
    try {
      phoneNumberService.format(value);
      return null;
    } catch (e) {
      return { error: "Invalid phone number" };
    }
  };
}